// extracted by mini-css-extract-plugin
export default {"fullWidth":"Jn-z","image":"Kn-z","lazyLoadPicture":"Ln-z","lazyLoadSpinner":"Mn-z","lazyLoadSpin":"Nn-z","lazyLoadImage":"On-z","hasStyledAspectRatio":"Pn-z"};